import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-box" }
const _hoisted_2 = ["innerHTML", "onKeyup"]

import talk from "@/api/talk";
import { nextTick, ref } from "vue";
import { useStore } from "vuex";
import UploadUtils from "@/utils/UploadUtils";
import { nanoid } from "nanoid";

export default /*#__PURE__*/_defineComponent({
  __name: 'Send',
  props: {
  rid: String,
},
  setup(__props) {

const props = __props;

const $store = useStore();

//输入框内容
const contenteditable = ref();
//拼音键入状态
const state = ref();
//拖拽上传
const drop = (e) => {
  e.preventDefault();
  update(e.dataTransfer.files);
};
//监听拼音输入开始
const start = () => {
  state.value = true;
};
//监听拼音输入结束
const end = (e) => {
  state.value = false;
  textarea.value += e.data;
  focus();
};
//监听输入框
function getMessage(e) {
  if (state.value) return;
  console.log(e.target.innerHTML);
  textarea.value = e.target.innerHTML;
  console.log(textarea.value);
  focus();
}
//聚焦
const focus = () => {
  nextTick(() => {
    let range = window.getSelection(); // 创建range
    range.selectAllChildren(contenteditable.value); // range 选择notesDom下所有子内容
    range.collapseToEnd();
  });
};
//粘贴
const paste = (e) => {
  e.preventDefault();
  if (e.clipboardData.files.length === 0) {
    textarea.value += e.clipboardData.getData("text/plain");
    focus();
    return;
  }
  update(e.clipboardData.files);
};
//输入框更新内容
const update = (files) => {
  const isImg = [...files].every((value) =>
    /\w.(png|jpg|jpeg|svg|webp|gif|bmp)$/i.test(value.type)
  );
  if (!isImg)
    return UploadUtils.getFile(
      { target: { files } },
      $store.state.talk.targetId,
      $store.state.talk.correlationId,
      Number(props.rid)
    );
  files.forEach((value) => {
    const url = window.URL.createObjectURL(value);
    textarea.value += `<img src="${url}" style="height:5rem;width:auto">`;
    focus();
  });
};
//不知道是啥
function enterBtn(event) {
  event.keyCode == 13 && event.preventDefault();
}
const textarea = ref<string>("");
//发送
const sendMessage = (): void => {
  let serviceRequestId = Number(props.rid);
  let targetId: string = $store.state.talk.targetId;
  let correlationId: string = $store.state.talk.correlationId;
  textarea.value.split(`<img src="`).forEach((value) => {
    if (value.includes("blob:http")) {
      fetch(value.split(`" style="height:5rem;width:auto">`)[0])
        .then((res) => res.blob())
        .then((blob) => {
          let file = new File(
            [blob],
            nanoid(20) + "." + blob.type.split("/")[1]
          );
          UploadUtils.getFile(
            { target: { files: [file] } },
            $store.state.talk.targetId,
            $store.state.talk.correlationId,
            Number(props.rid)
          );
          const dom = document.createElement("div");
          dom.innerHTML = `<pre>${
            value.split(`" style="height:5rem;width:auto">`)[1]
          }</pre>`;
          value.split(`" style="height:5rem;width:auto">`)[1] &&
            talk.sendMessage(
              targetId,
              correlationId,
              serviceRequestId,
              dom.innerText
            );
        });
    } else {
      const dom = document.createElement("div");
      console.log(dom);
      dom.innerHTML = `<pre>${value} </pre>`;
      value &&
        talk.sendMessage(
          targetId,
          correlationId,
          serviceRequestId,
          dom.innerText
        );
    }
  });
  textarea.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      contenteditable: "",
      class: "textarea",
      onDrop: drop,
      onPaste: paste,
      onInput: getMessage,
      ref_key: "contenteditable",
      ref: contenteditable,
      innerHTML: textarea.value,
      onCompositionstart: start,
      onCompositionend: end,
      onKeydown: enterBtn,
      onKeyup: _withKeys(sendMessage, ["enter"])
    }, null, 40, _hoisted_2), [
      [_vShow, _unref($store).state.talk.serviceExpireTime[props.rid] != 11]
    ]),
    _withDirectives(_createVNode(_component_el_button, {
      class: "send",
      type: "primary",
      onClick: sendMessage
    }, {
      default: _withCtx(() => [
        _createTextVNode("发送")
      ]),
      _: 1
    }, 512), [
      [_vShow, _unref($store).state.talk.serviceExpireTime[props.rid] != 11]
    ])
  ]))
}
}

})